import { QueueColumnNames as Cols } from "./shared";

/*
 * The ordering of the arrays below controls
 * which columns show, and in what order
 */

const commonPreAppCols = [
  Cols.LoanApplicationID,
  Cols.PropertyState,
  Cols.LeadNumber,
  Cols.Borrower1Name,
];

const commonRESPACols = [
  Cols.LoanApplicationID,
  Cols.PropertyState,
  Cols.LoanID,
  Cols.Borrower1Name,
];

/* ******************** */
// PreApplication Recipes
/* ******************** */
export const colsForInitialBorrowerUnderwrite = [
  ...commonPreAppCols,
  Cols.CreditScore,
  Cols.RegistrationDate,
  Cols.OutstandingDocuments,
  Cols.PreAppUWDue,
  Cols.CashCloseType,
  Cols.BorrowerEstimatedLoanAmount,
  Cols.BorrowerEstimatedPurchasePrice,
  Cols.LoanStatus,
  Cols.LoanStatusDate,
  Cols.AssignedUnderwriterName,
];

export const colsForTasksToComplete = [
  ...commonPreAppCols,
  Cols.RegistrationDate,
  Cols.UWTaskCount,
  Cols.UWTaskFirstDueBy,
  Cols.LoanDecision,
  Cols.LoanDecisionDate,
  Cols.AssignedUnderwriterName,
];

export const colsForConditionsReadyToReview = [
  ...commonPreAppCols,
  Cols.RegistrationDate,
  Cols.PreAppUWDue,
  Cols.ConditionsPreReadyToReview,
  Cols.ConditionsReadyToReview,
  Cols.ConditionResponseDue,
  Cols.MessageResponseDue,
  Cols.LoanDecision,
  Cols.LoanDecisionDate,
  Cols.AssignedUnderwriterName,
];

export const colsForBorrowerMessage = [
  ...commonPreAppCols,
  Cols.RegistrationDate,
  Cols.PreAppUWDue,
  Cols.ConditionResponseDue,
  Cols.MessagesToReview,
  Cols.MessageResponseDue,
  Cols.LoanDecision,
  Cols.LoanDecisionDate,
  Cols.AssignedUnderwriterName,
];

export const colsForSecondReviewForMortgageDenial = [
  ...commonPreAppCols,
  Cols.CreditScore,
  Cols.PreAppAANDue,
  Cols.PreAppAANSent,
  Cols.PreAppAANReason,
  Cols.LoanStatus,
  Cols.LoanStatusDate,
  Cols.LoanDecision,
  Cols.LoanDecisionDate,
];

export const colsForCreditReportPullIssues = [
  ...commonPreAppCols,
  Cols.CreditScore,
  Cols.RegistrationDate,
  Cols.PreAppUWDue,
  Cols.BorrowerEstimatedLoanAmount,
  Cols.BorrowerEstimatedPurchasePrice,
  Cols.LoanStatus,
  Cols.LoanStatusDate,
  Cols.AssignedUnderwriterName,
];

export const colsForFICODeclines = [
  ...commonPreAppCols,
  Cols.CreditScore,
  Cols.PreAppAANDue,
  Cols.PreAppAANSent,
  Cols.PreAppAANReason,
  Cols.LoanStatus,
  Cols.LoanStatusDate,
  Cols.LoanDecision,
  Cols.LoanDecisionDate,
];

export const colsSendForNoticeOfIncompleteApplication = [
  ...commonPreAppCols,
  Cols.CreditReportDate,
  Cols.NOIADue,
  Cols.NOIATimestamp,
  Cols.NOIAFollowup,
  Cols.LoanStatus,
  Cols.LoanStatusDate,
  Cols.LoanDecision,
  Cols.LoanDecisionDate,
];

/* ******************** */
// RESPA Complete Recipes
/* ******************** */
export const colsRESPAForTasksToComplete = [
  ...commonRESPACols,
  Cols.ApplicationDate,
  Cols.ClosingDate,
  Cols.UWTaskCount,
  Cols.UWTaskFirstDueBy,
  Cols.LoanDecision,
  Cols.LoanDecisionDate,
  Cols.AssignedUnderwriterName,
];

export const colsRESPACompleteConditionsReadyToReview = [
  ...commonRESPACols,
  Cols.ApplicationDate,
  Cols.ClosingDate,
  Cols.ConditionsPreReadyToReview,
  Cols.ConditionsReadyToReview,
  Cols.ConditionResponseDue,
  Cols.MessageResponseDue,
  Cols.LoanDecision,
  Cols.LoanDecisionDate,
  Cols.RegBCreditDecisionDue,
  Cols.AssignedUnderwriterName,
];

export const colsRESPACompleteBorrowerMessage = [
  ...commonRESPACols,
  Cols.ApplicationDate,
  Cols.ClosingDate,
  Cols.ConditionResponseDue,
  Cols.MessagesToReview,
  Cols.MessageResponseDue,
  Cols.LoanDecision,
  Cols.LoanDecisionDate,
  Cols.RegBCreditDecisionDue,
  Cols.AssignedUnderwriterName,
];

export const colsRESPACompleteInitialBorrowerUnderwrites = [
  ...commonRESPACols,
  Cols.ApplicationDate,
  Cols.ClosingDate,
  Cols.LoanStatus,
  Cols.LoanStatusDate,
  Cols.LoanDecision,
  Cols.LoanDecisionDate,
  Cols.RegBCreditDecisionDue,
  Cols.AssignedUnderwriterName,
];

export const colsRESPACompleteSecondReviewForMortgageDenial = [
  ...commonRESPACols,
  Cols.ApplicationDate,
  Cols.ClosingDate,
  Cols.LoanStatus,
  Cols.LoanStatusDate,
  Cols.LoanDecision,
  Cols.LoanDecisionDate,
  Cols.RegBCreditDecisionDue,
  Cols.AssignedUnderwriterName,
];

export const colsRESPAUWAppraisalReview = [
  ...commonRESPACols,
  Cols.ApplicationDate,
  Cols.ClosingDate,
  Cols.LoanStatus,
  Cols.LoanStatusDate,
  Cols.LoanDecision,
  Cols.LoanDecisionDate,
  Cols.AppraisalReceivedDate,
  Cols.AssignedUnderwriterName,
];
